<template>
  <layout-header></layout-header>
  <layout-sidebar></layout-sidebar>

  <!-- Page Wrapper -->
  <div class="page-wrapper">
    <div class="content container-fluid">
      <!-- Page Header -->
      <div class="page-header subscribe-head">
        <div class="row align-items-center">
          <breadcrumbthree :title="title" :text="text" :text1="text1" />

          <div class="col-auto">
            <a
              class="btn add-user"
              href="javascript:;"
              data-bs-toggle="modal"
              data-bs-target="#add"
              @click="clearValuesUser()"
            >
              <i class="fas fa-plus"></i> Agregar Usuario
            </a>
          </div>
        </div>
      </div>
      <!-- /Page Header -->
      
      <div class="row">
        <div class="col-sm-12">
          <div class="card">
            <div class="card-body">
              <div class="showentries">
                <label
                  >Mostrando
                  <select>
                    <option value="10">10</option>
                    <option value="25">25</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                  </select>
                  registros
                </label>
                <div class="entries">
                  <span>Buscar: </span>
                  <input
                    type="search"
                    class="form-control form-control-sm ms-2"
                    placeholder=""
                    v-model = "searchedValue"
                    @input="localSearch()"
                  />
                </div>
              </div>
              <div class="table-responsive">
                <a-table
                  class="stripped table-hover"
                  :columns="columns"
                  :data-source="filteredData"
                >
                  <template #bodyCell="{ column, record }">
                    <template v-if="column.key === 'Nombre'">
                      <div>{{ record.UsuarioName }}</div>
                    </template>
                    <template v-else-if="column.key === 'id'">
                      <div class="text-end">
                        <a
                          href="javascript:void(0);"
                          class="btn btn-sm btn-secondary me-2"
                          data-bs-toggle="modal"
                          data-bs-target="#edit"
                          @click="loadEditModal(record)"
                          ><i class="far fa-edit"></i
                        ></a>
                        <a
                          href="javascript:void(0);"
                          class="btn btn-sm btn-danger"
                          data-bs-toggle="modal"
                          data-bs-target="#delete"
                          @click="loadDeleteModal(record)"
                          ><i class="far fa-trash-alt"></i
                        ></a>
                      </div>
                    </template>
                  </template>
                </a-table>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
  <!-- /Page Wrapper -->

  <!-- Add Modal -->
  <div class="modal fade custom-modal" id="add">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <!-- Modal Header -->
        <div class="modal-header">
          <h4 class="modal-title">Agregar Usuario</h4>
          <button type="button" class="close" data-bs-dismiss="modal">
            <span>&times;</span>
          </button>
        </div>

        <!-- Modal body -->
        <div class="modal-body">
          <form @submit.prevent="addUser">
            <div class="form-group">
              <label>Nombres</label>
              <input type="text" class="form-control" v-model="nombres" required ref="first_input"/>
            </div>
            <div class="form-group">
              <label>Apellido Paterno</label>
              <input type="text" class="form-control" v-model="appaterno" required/>
            </div>
            <div class="form-group">
              <label>Apellido Materno</label>
              <input type="text" class="form-control" v-model="apmaterno" required/>
            </div>
            <div class="form-group">
              <label>Rol</label>
              <select class="form-control form-select" v-model="rol" required>
                <option>Seleccionar</option>
                <option 
                v-for="rol in roles" 
                :key="rol" 
                :value="rol"
                >
                {{ rol }}
                </option>
              </select>
            </div>
            <div class="form-group">
              <label>Correo Corporativo</label>
              <input type="text" class="form-control" v-model="correo" required/>
            </div>
            <div class="mt-4">
              <button type="submit" class="btn btn-agv-dos btn-block" data-bs-dismiss="modal">Guardar</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
  <!-- /The Modal -->

  <!-- Edit Modal -->
  <div class="modal fade custom-modal" id="edit">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <!-- Modal Header -->
        <div class="modal-header">
          <h4 class="modal-title">Editar Usuario</h4>
          <button type="button" class="close" data-bs-dismiss="modal">
            <span>&times;</span>
          </button>
        </div>
        <!-- Modal body -->
        <div class="modal-body">
          <form @submit.prevent="editUser">
            <div class="form-group">
              <label>Nombres</label>
              <input type="text" class="form-control" v-model="nombres" required/>
            </div>
            <div class="form-group">
              <label>Apellido Paterno</label>
              <input type="text" class="form-control" v-model="appaterno" required/>
            </div>
            <div class="form-group">
              <label>Apellido Materno</label>
              <input type="text" class="form-control" v-model="apmaterno" required/>
            </div>
            <div class="form-group">
              <label>Rol</label>
              <select class="form-control form-select" v-model="rol" required>
                <option>Seleccionar</option>
                <option 
                v-for="rol in roles" 
                :key="rol" 
                :value="rol"
                >
                {{ rol }}
                </option>
              </select>
            </div>
            <div class="form-group">
              <label>Correo Corporativo</label>
              <input type="text" class="form-control" v-model="correo" required/>
            </div>
            <div class="mt-4">
              <button type="submit" class="btn btn-agv-dos btn-block" data-bs-dismiss="modal">Guardar</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
  <!-- /Edit Modal -->

  <!-- Delete modal -->
  <div class="modal custom-modal fade" id="delete" role="dialog">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-body">
          <div class="form-header">
            <h3>Eliminar</h3>
            <p>¿Esta seguro de eliminar este registro de forma permanente?</p>
          </div>
          <div class="modal-btn delete-action">
            <div class="row">
              <div class="col-6">
                <a href="javascript:void(0);" class="btn btn-agv-dos continue-btn" data-bs-dismiss="modal" @click="deleteUser(record)"
                  >Eliminar</a
                >
              </div>
              <div class="col-6">
                <a
                  href="javascript:void(0);"
                  data-bs-dismiss="modal"
                  class="btn btn-agv-dos cancel-btn"
                  >Cancelar</a
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- /Delete modal -->



</template>

<script>
const columns = [
  // {
  //   title: "N°",
  //   dataIndex: "idusuario",
  //   key: "idusuario",
  //   sorter: true,
  // },
  {
    title: "Nombre completo",
    dataIndex: "fullname",
    key: "fullname",
    sorter: {
      compare: (a, b) => {
        a = a.fullname.toLowerCase();
        b = b.fullname.toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: "Correo",
    dataIndex: "email",
    key: "email",
    sorter: {
      compare: (a, b) => {
        a = a.email.toLowerCase();
        b = b.email.toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: "Rol",
    dataIndex: "type_user",
    key: "type_user",
    sorter: {
      compare: (a, b) => {
        a = a.type_user.toLowerCase();
        b = b.type_user.toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: "Acciones",
    key: "id",
    class: "text-end",
    sorter: true,
  },
];

// const data = [
//   {
//     No: 1,
//     nombres: "Alex Guillén",
//     nombreUsuario: "aguillen",
//     rol: "Admin",
//     Actions: "",
//   },
// ];
import { ref } from 'vue';
import axiosIns from '../../../../../plugins/axios.js';
const currentDate = ref(new Date());
export default {
  data() {
    return {
      columns,
      title: "Usuarios",
      text: "Mantenimientos",
      text1: "Usuarios",
      filterInputsDisplay: "none",
      startdate: currentDate,

      data : [],
      filteredData : [],
      searchedValue : null,
      id: null,
      nombres: null,
      appaterno: null,
      apmaterno: null,
      rol: null,
      correo:null,

      mostrarModalEditar : false,
      roles : ['Administrador','Reclutador','Usuario Estandar'],
    };
  },
  mounted(){
    this.getUsers()
  },
  methods: {

    addUser(){
      const yo = this       
      const data = JSON.stringify({
        name : yo.nombres,
        first_surname : yo.appaterno,
        second_surname : yo.apmaterno,
        type_user : yo.rol,
        email : yo.correo,
      })

      const config = {
        method: 'post',
        url: '/talentoagv/createUser/',
        headers: {
          'Content-Type': 'application/json'
        },
        data: data,
      }

      axiosIns(config)
        .then(function (response) {
          if (response.status === 200){
            yo.getUsers()

            yo.$toastr.success(response.data['message'], 'Éxito')
          }
        })
        .catch(function (error) {
          console.log(error);
          yo.$toastr.error(response.data['message'], 'Error')
        })
        .finally(function (){
          
        })
    },

    getUsers(){
      const yo = this
      const config = {
        method: 'get',
        url: '/talentoagv/readUsers/',
      }

      axiosIns(config)
        .then(function (response) {
          // console.log(response.data['result'])
          if (response.data['is_error'] === false){
            let resultado = response.data['result']
            for (let r of resultado) {
              let fullName = r['name'] + ' ' + r['first_surname'] + ' ' + r['second_surname'];
              r['fullname'] = fullName; 
            }
            yo.data = resultado
            yo.filteredData = resultado
            // yo.$toastr.success(response.data['message'], 'Éxito')
          }
        })
        .catch(function (error) {
          console.log(error);
          yo.$toastr.error(response.data['message'], 'Error')
        })
        .finally(function (){
          
        })
    },

    loadEditModal(datos){
      const yo = this
      yo.id = datos['id']
      yo.nombres = datos['name']
      yo.appaterno = datos['first_surname']
      yo.apmaterno = datos['second_surname']
      yo.rol = datos['type_user']
      yo.correo = datos['email']
    },

    editUser(){
      const yo = this       
      const data = JSON.stringify({
        id : yo.id,
        name : yo.nombres,
        first_surname : yo.appaterno,
        second_surname : yo.apmaterno,
        type_user : yo.rol,
        email : yo.correo,
      })

      const config = {
        method: 'post',
        url: '/talentoagv/updateUser/',
        headers: {
          'Content-Type': 'application/json'
        },
        data: data,
      }

      axiosIns(config)
        .then(function (response) {
          // console.log(response.data)
          if (response.data['is_error'] === false){
            yo.$toastr.success(response.data['message'], 'Éxito')
            yo.getUsers()
          }
        })
        .catch(function (error) {
          console.log(error);
          yo.$toastr.error(response.data['message'], 'Error')
        })
        .finally(function (){
          
        })
    },

    loadDeleteModal(datos){
      const yo = this
      yo.id = datos['id']
    },

    deleteUser(){
      const yo = this       
      const data = JSON.stringify({
        id: yo.id,
      })

      const config = {
        method: 'post',
        url: '/talentoagv/deleteUser/',
        headers: {
          'Content-Type': 'application/json'
        },
        data: data,
      }

      axiosIns(config)
        .then(function (response) {
          // console.log(response.data)
          if (response.data['is_error'] === false){
            yo.$toastr.success(response.data['message'], 'Éxito')
            yo.getUsers()
          }
        })
        .catch(function (error) {
          console.log(error);
          yo.$toastr.error(response.data['message'], 'Error')
        })
        .finally(function (){
          
        })
    },

    clearValuesUser(){
      const yo = this
      yo.id = null
      yo.nombres = ''
      yo.appaterno = null
      yo.apmaterno = null
      yo.rol = null
      yo.correo = null
    },

    localSearch(){
      console.log("Buscando")
      const yo = this
      let data = yo.data
      let searched_value = yo.searchedValue.toLowerCase() // Convertir a minúsculas para búsqueda case insensitive
      let resultados = []
      
      // Recorrer cada objeto en la lista de datos
      for (let obj of data) {
        // Recorrer cada propiedad (campo) del objeto
        for (let key in obj) {
          // Verificar si el valor de la propiedad contiene la palabra clave buscada
          if (typeof obj[key] === 'string' && obj[key].toLowerCase().includes(searched_value)) {
            resultados.push(obj); // Retornar el objeto completo si se encuentra la palabra clave
            break;
          }
        }
      }

      if(resultados){
        yo.filteredData = resultados
      }else{
        yo.filteredData = yo.data
      }
    },

  },
};
</script>
